/** Compact search and ranking-state filters, with counts for the whole queue. */
import { FC } from 'react';

import { SearchInput, SegmentedPills } from '@/components/ui';

import { type ListResult, type ResultFilter, RESULT_LABEL } from './results-model';

const FILTERS: ResultFilter[] = ['all', 'ranked', 'no-traffic', 'excluded'];

export const ResultsToolbar: FC<{
  rows: ListResult[];
  filter: ResultFilter;
  onFilter: (value: ResultFilter) => void;
  search: string;
  onSearch: (value: string) => void;
}> = ({ rows, filter, onFilter, search, onSearch }) => (
  <div className="flex shrink-0 flex-wrap items-center gap-2 border-b border-border/60 px-3 pb-3">
    <div role="group" aria-label="Filter lists by ranking status">
      <SegmentedPills options={FILTERS.map((value) => ({value, label: value === 'all' ? 'All lists' : RESULT_LABEL[value], count: value === 'all' ? rows.length : rows.filter((row) => row.kind === value).length}))}
        value={filter} onChange={onFilter} className="[&>div]:flex-wrap" />
    </div>
    <SearchInput aria-label="Search lists by name, tag or ID" placeholder="Search list name, tag or ID…" value={search} onValueChange={onSearch}
      containerClassName="min-w-[12rem]" className="h-8 text-xs" />
  </div>
);
